import React from 'react'
import { Target, TrendingUp } from 'lucide-react'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@rewardops/replit/src/components/ui/card'
import { Spinner } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const Goals: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()

  const { data: goalsData, isLoading } = api.pawDashboards.getByRole.useQuery({
    role: data?.role,
    // sectionId: data?.sectionId,
    sectionId: 'goals',
  })

  const formatCamelCase = (str: string): string => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }

  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Organizational Goals - 2026'}
      </h2>
      <div className="grid gap-6 md:grid-cols-2">
        {isLoading && <Spinner />}
        {!isLoading &&
          Object.keys(goalsData)
            ?.filter((key: string) => key !== 'ytdTotals')
            ?.map((key: string) => (
              <Card key={key}>
                <CardHeader className="pb-3">
                  <CardTitle className="flex items-center gap-2 text-base font-medium">
                    <Target className="h-5 w-5" />
                    {formatCamelCase(key)} Goals
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  {Object.keys(goalsData?.[key])?.map((nestedKey: string) => (
                    <div id={`${key}_${nestedKey}`}>
                      <div className="mb-2 flex items-center justify-between">
                        <span className="text-sm text-muted-foreground">
                          {formatCamelCase(nestedKey)}
                        </span>
                        <span className="text-sm font-medium">
                          {Math.round(
                            (goalsData?.ytdTotals?.[nestedKey] /
                              goalsData?.[key]?.[nestedKey]) *
                              100,
                          )}
                          % of $
                          {(goalsData?.[key]?.[nestedKey] / 1000000).toFixed(2)}
                          M
                        </span>
                      </div>

                      <div className="relative h-2 overflow-hidden rounded-full bg-secondary">
                        <div
                          className="absolute left-0 top-0 h-full bg-emerald-500 transition-all duration-500"
                          style={{
                            width: `${Math.min(
                              100,
                              (goalsData?.ytdTotals?.[nestedKey] /
                                goalsData?.[key]?.[nestedKey]) *
                                100,
                            )}%`,
                          }}
                        />
                      </div>
                      <div className="mt-1 flex items-center justify-between">
                        <span className="text-xs text-muted-foreground">
                          $
                          {(
                            goalsData?.ytdTotals?.[nestedKey] / 1000000
                          ).toFixed(1)}
                          M YTD
                        </span>
                        <span className="text-xs text-muted-foreground">
                          $
                          {(goalsData?.[key]?.[nestedKey] / 1000000).toFixed(0)}
                          M
                        </span>
                      </div>
                    </div>
                  ))}
                </CardContent>
              </Card>
            ))}
      </div>
    </section>
  )
}
